import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";

class ItemList extends Component {
    state = {
        yummy_items : [],
    };

    componentDidMount(){
       

        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        axios
        .post('https://pykin.in/public/api/exclusive-items', {
            latitude: userSetAddress.lat,
            longitude: userSetAddress.lng, 
        })
        .then((response) => {
            const yummy_items = response.data.items;

            if (yummy_items.length) {
                this.setState({
                    yummy_items: response.data.items
                });

            } else {
                this.setState({
                    yummy_items: [],
                });
            }
        });
    }

    render() {
        // const {  } = this.props;


		return (
            <React.Fragment>
                {this.state.yummy_items.length > 0 && (
                    <span style={{"fontSize":"large","paddingLeft":"10px","fontWeight":"bold"}}>Suggestions For You</span>
                )}
                <div className="mr-15 ml-15 mt-10" style={{ display: "grid", gridTemplateColumns: "repeat(3, 2fr)", gridGap: 10 }}>
                    {this.state.yummy_items.map((yummy_item, index) => (
						<LazyLoad>
                        <DelayLink to={yummy_item.slug} key={yummy_item.id}>
						<div style={{
							backgroundImage: `url("${localStorage.getItem('cdn') + yummy_item.image}")`,
							width: '100%',
							height: '8rem',
							borderRadius: '0.6rem',
							backgroundSize: 'cover',
							}}>
								{/* {yummy_item.is_recommended == 1 && (<div style={{
									    position: 'relative',
										display: 'flex',
										top: '10px',
										left: '10px',
										width: 'fit-content',
										borderRadius: '4px',
										padding: '4px',
										backgroundColor: 'red'
										
								}} className="font-weight-bold text-white">Top-Item</div> )} */}
							</div>
						<div>
							<p className="mb-0 pl-5 font-size-ml" style={{
								    maxHeight: '18px',
									overflowY: 'hidden',
								}}>{yummy_item.name}</p>
								<div className="pl-5">
								{localStorage.getItem("hidePriceWhenZero") === "true" &&
											yummy_item.price === "0.00" ? null : (
												<React.Fragment className="">
													{yummy_item.old_price > 0 && (
														<span className="strike-text mr-1">
															{" "}
															{localStorage.getItem("currencySymbolAlign") === "left" &&
																localStorage.getItem("currencyFormat")}{" "}
															{yummy_item.old_price}
															{localStorage.getItem("currencySymbolAlign") === "right" &&
																localStorage.getItem("currencyFormat")}
														</span>
													)}

													<span>
													<b>{localStorage.getItem("currencySymbolAlign") === "left" &&
															localStorage.getItem("currencyFormat")}{" "}
														{yummy_item.price}
														{localStorage.getItem("currencySymbolAlign") === "right" &&
															localStorage.getItem("currencyFormat")}</b>
													</span>

													{yummy_item.old_price > 0 &&
														localStorage.getItem("showPercentageDiscount") === "true" && (
															<React.Fragment>
																<span
																	className="price-percentage-discount mb-0 ml-1"
																	style={{
																		color: localStorage.getItem("cartColorBg"),
																	}}
																>
																	<b>{parseFloat(
																		((parseFloat(yummy_item.old_price) -
																			parseFloat(yummy_item.price)) /
																			parseFloat(yummy_item.old_price)) *
																			100
																	).toFixed(0)}
																	{localStorage.getItem("itemPercentageDiscountText")}
																	</b>
																</span>
															</React.Fragment>
														)}
												</React.Fragment>
											)}
											{yummy_item.addon_categories.length > 0 && (
												<span
													className="ml-2 customizable-item-text"
													style={{
														color: localStorage.getItem("storeColor"),
													}}
												>
													{localStorage.getItem("customizableItemText")}
												</span>
											)}
										</div>
						</div>
					</DelayLink>     
					</LazyLoad>               ))}
                </div>
               
            </React.Fragment>
        );
    }
}

export default ItemList;
